import React from 'react';

import { flagStyles } from '../settings';

const SvgLY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3216px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLY;
